import { render, staticRenderFns } from "./TravelExceptional.vue?vue&type=template&id=00ef2c54&"
import script from "./TravelExceptional.vue?vue&type=script&lang=js&"
export * from "./TravelExceptional.vue?vue&type=script&lang=js&"
import style0 from "./TravelExceptional.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelExceptional.vue"
export default component.exports